import React, { Fragment, useCallback } from 'react';
import { IntlShape } from 'react-intl';
import * as Styled from './AskProductOrderList.styles';
import { ISortedOrders, ISortedProject, RepList } from '../../types';
import { AskProductOrderItem } from '../AskProductOrderItem';

interface AskProductOrderListProps {
  orders: ISortedOrders;
  onActionClick: (itemID: string) => void;
  representatives?: RepList;
  intl: IntlShape;
}

export const AskProductOrderList: React.FC<AskProductOrderListProps> = (
  props,
) => {
  const {
    orders: { products },
    representatives,
    onActionClick,
    intl,
  } = props;

  const renderOrderItem = useCallback(
    // @ts-expect-error // TODO: fix types
    (sortedProject: ISortedProject, brandName: string, orderDate) => {
      const { itemID, products, project, order_id } = sortedProject;

      if (!representatives) {
        return null;
      }

      const representativesForBrand =
        representatives[sortedProject.products[0].manufacturer_id];
      const props = {
        itemID,
        brand: brandName,
        products,
        project,
        representatives: representativesForBrand,
        onActionClick,
        orderID: order_id,
        orderDate,
      };

      return <AskProductOrderItem key={itemID} intl={intl} {...props} />;
    },
    [representatives, onActionClick, intl],
  );

  return (
    <Styled.AskProductOrderListWrapper>
      {products &&
        Object.keys(products).map((projectName, i) => {
          if (!products[projectName]) {
            return null;
          }
          return (
            <Fragment key={i}>
              <Styled.ProjectName variant="body" fontWeight={600}>
                {projectName}
              </Styled.ProjectName>
              <Styled.OrderList compact={false}>
                {Object.keys(products[projectName]).map((brandName, k) => {
                  return (
                    <Fragment key={k}>
                      {Object.keys(products[projectName][brandName]).map(
                        (orderDate) => {
                          return renderOrderItem(
                            products[projectName][brandName][orderDate],
                            brandName,
                            orderDate,
                          );
                        },
                      )}
                    </Fragment>
                  );
                })}
              </Styled.OrderList>
            </Fragment>
          );
        })}
    </Styled.AskProductOrderListWrapper>
  );
};
